import { useState, useContext } from 'react';
import { AuthContext } from '../../../components/Auth/AuthProvider';
import {
  Box,
  Typography,
  Button,
  Paper,
  Alert,
  CircularProgress,
  Stack,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { FeatureFlagList } from './FeatureFlagList';
import { FeatureFlagForm } from './FeatureFlagForm';

export const FeatureFlagAdmin: React.FC = () => {
  const { loading } = useContext(AuthContext);
  const [error, setError] = useState<string | null>(null);
  const [showCreateForm, setShowCreateForm] = useState(false);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      {error && (
        <Alert severity='error' sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      <Stack
        direction='row'
        alignItems='center'
        spacing={2}
        sx={{ mb: 3 }}
        justifyContent='space-between'
      >
        <Typography variant='h4'>Feature Flag Management</Typography>

        {!showCreateForm && (
          <Button
            variant='contained'
            onClick={() => setShowCreateForm(true)}
            startIcon={<AddIcon />}
          >
            Create New Feature Flag
          </Button>
        )}
      </Stack>

      {showCreateForm && (
        <Paper sx={{ p: 3, mb: 3 }}>
          <FeatureFlagForm
            onCancel={() => setShowCreateForm(false)}
            onError={setError}
          />
        </Paper>
      )}

      <FeatureFlagList onError={setError} />
    </Box>
  );
};
